import React, { useState } from "react";
import CommonInput from "../../../../Layouts/CommonInput";
import Style from "./ClientDetailsForm.module.scss";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import useAddNewProjects from "../../../../../Logic/useAddNewProjects";
import InfiniteDotLoader from "../../../../../utils/InfiniteDotLoader";
import { useDispatch, useSelector } from "react-redux";
import { getCounts } from "../../../../../store/slices/Dashboard/getDashboardSlice";

let hasErrors = false;

export const ClientDetailsForm = ({
  setOpenCreateProjectModal,
  setAddProjectStepOne,
  setAddProjectStepTwo,
  handleCancel,
}) => {
  const dispatch = useDispatch();
  const { storeClientData, errorMessage, visibleError } = useAddNewProjects();

  const { isLoading } = useSelector((state) => state.project.addProjects);
  const { addProjects, clientValidation } = useSelector(
    (state) => state.project
  );
  const [initialInput, setInitialInputs] = useState({
    clientName: "",
    email: "",
    mobile: "",
    dial_code: "+91",
    sec_email: "",
    sec_mobile: "",
    sec_dial_code: "+91",
  });

  const phoneRegExp = /^(0*[1-9][0-9]*(\.[0-9]*)?|0*\.[0-9]*[1-9][0-9]*)$/;

  const SignupSchema = Yup.object().shape({
    clientName: Yup.string()
      .trim()
      .matches(/^\S.*$/, "Client Name must not start with a space")
      .required("Client Name is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    sec_email: Yup.string().email("Invalid email format"),
    mobile: Yup.string()
      .matches(phoneRegExp, "Invalid phone number")
      .required("Phone number is required")
      .min(10, "Min 10 digits is required")
      .max(10, "Max 10 digits is allowed"),
    sec_mobile: Yup.string()
      .matches(phoneRegExp, "Invalid phone number")
      .min(10, "Min 10 digits is required")
      .max(10, "Max 10 digits is allowed"),
  });

  const handleValidate = (values) => {
    let errors = {};
    if (values?.mobile === values.sec_mobile) {
      errors.sec_mobile =
        "Secondary mobile can't be the same as primary mobile";
    } else {
      errors = {};
    }
    return errors;
  };

  return (
    <Formik
      initialValues={initialInput}
      validate={handleValidate}
      onSubmit={(values, { resetForm, setFieldError }) => {
        let formData = {
          project_id: "",
          name: values.clientName,
          email: values.email,
          mobile: values.mobile,
          country_code: values.dial_code,
          sec_email: values.sec_email,
          sec_mobile: values.sec_mobile,
          sec_country_code: values.sec_dial_code,
        };

        storeClientData({ setFieldError: setFieldError, formData: formData });
        dispatch(getCounts());
      }}
      validationSchema={SignupSchema}
      enableReinitialize={true}
      validateOnBlur={true}
    >
      {({
        errors,
        touched,
        values,
        handleBlur,
        handleSubmit,
        setFieldValue,
        dirty,
        isValid,
      }) => {
        hasErrors = Object.keys(errors).length == 0;
        return (
          <>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-lg-12">
                  <CommonInput
                    label="Client Name*"
                    variant="input"
                    id="input_client_name"
                    name="clientName"
                    floatingLabel={true}
                    value={values.clientName}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      setFieldValue("clientName", e.target.value);
                    }}
                    // hasError={errors?.clientName && touched.clientName}
                    // errorMsg={errors?.clientName}
                  />
                  <p
                    className="error text-danger"
                    style={{ marginTop: "-12px", fontSize: "12px" }}
                  >
                    {errors?.clientName && touched.clientName
                      ? errors?.clientName
                      : "" ||
                        (clientValidation?.validation?.errors?.clientName &&
                          visibleError)
                      ? clientValidation?.validation?.errors?.clientName
                      : ""}
                  </p>
                </div>
                <div className="col-lg-6">
                  <CommonInput
                    label="Email*"
                    type="email"
                    variant="input"
                    id="input_email"
                    name="email"
                    floatingLabel={true}
                    value={values.email}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      setFieldValue("email", e.target.value);
                    }}
                    // hasError={errors?.email && touched.email}
                    // errorMsg={errors?.email}
                  />
                  <p
                    className="error text-danger"
                    style={{ marginTop: "-12px", fontSize: "12px" }}
                  >
                    {errors?.email && touched.email
                      ? errors?.email
                      : "" ||
                        (clientValidation?.validation?.errors?.email &&
                          visibleError)
                      ? clientValidation?.validation?.errors?.email
                      : ""}
                  </p>
                </div>

                <div className="col-lg-6">
                  <CommonInput
                    label="Mobile*"
                    variant="phone-with-country"
                    floatingLabel={true}
                    name="mobile"
                    id="mobile"
                    default_country="IN"
                    value={values.mobile}
                    // country_dial_code={""}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      setFieldValue("mobile", e.target.value);
                    }}
                    callback={function (country) {
                      setFieldValue("dial_code", country.dial_code);
                    }}
                    // hasError={errors?.mobile && touched.mobile}
                    // errorMsg={errors?.mobile}
                  />
                  <p
                    className="error text-danger"
                    style={{ marginTop: "-12px", fontSize: "12px" }}
                  >
                    {errors?.mobile && touched.mobile
                      ? errors?.mobile
                      : "" ||
                        (clientValidation?.validation?.errors?.phone &&
                          visibleError)
                      ? clientValidation?.validation?.errors?.phone
                      : ""}
                  </p>
                </div>

                <div className="col-lg-6">
                  <CommonInput
                    label="Additional Email"
                    type="email"
                    variant="input"
                    id="sec_email"
                    floatingLabel={true}
                    value={values.sec_email}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      setFieldValue("sec_email", e.target.value);
                    }}
                    // hasError={errors?.sec_email && touched.sec_email}
                    // errorMsg={errors?.sec_email}
                  />
                  <p
                    className="error text-danger"
                    style={{ marginTop: "-12px", fontSize: "12px" }}
                  >
                    {errors?.sec_email && touched.sec_email
                      ? errors?.sec_email
                      : ""}
                  </p>
                </div>
                <div className="col-lg-6">
                  <CommonInput
                    label="Additional Mobile"
                    variant="phone-with-country"
                    floatingLabel={true}
                    id="sec_mobile"
                    default_country="IN"
                    value={values.sec_mobile}
                    // country_dial_code={""}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      setFieldValue("sec_mobile", e.target.value);
                    }}
                    callback={function (country) {
                      setFieldValue("sec_dial_code", country.sec_dial_code);
                    }}
                    // hasError={errors?.sec_mobile && touched.sec_mobile}
                    // errorMsg={errors?.sec_mobile}
                  />
                  <p
                    className="error text-danger"
                    style={{ marginTop: "-12px", fontSize: "12px" }}
                  >
                    {errors?.sec_mobile && touched.sec_mobile
                      ? errors?.sec_mobile
                      : ""}
                  </p>
                </div>
                <p
                  className="error text-danger"
                  style={{
                    marginTop: "10px",
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                >
                  {(errorMessage &&
                    addProjects?.stepTwoFormData?.result?.result?.message) ||
                    (clientValidation?.result?.status === false
                      ? clientValidation?.result?.msg
                      : "")}
                </p>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-border-grey"
                  onClick={() => {
                    handleCancel(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  disabled={!isValid || !dirty || isLoading}
                  className="btn btn-primary"
                  type="submit"
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  {isLoading ? <InfiniteDotLoader /> : "Next"}
                </button>
              </div>
            </form>
          </>
        );
      }}
    </Formik>
  );
};
